import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=0f27d8e0"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f27d8e0')) {
      api.createRecord('0f27d8e0', component.options)
    } else {
      api.reload('0f27d8e0', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=0f27d8e0", function () {
      api.rerender('0f27d8e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/po/Item.vue"
export default component.exports